import React from 'react';
import { Crown, Check, Zap, Star, Rocket, Building2 } from 'lucide-react';
import { SubscriptionSection } from '../billing/SubscriptionSection';

const PlanSection = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h2 className="text-2xl font-semibold text-neutral-900 dark:text-white mb-2">Kolega Studio</h2>
        <p className="text-neutral-600 dark:text-neutral-400">Comprehensive AI-powered ideation, code generation and deployment Studio.</p>
      </div>

      {/* Subscription Section */}
      <SubscriptionSection />

      {/* Divider */}
      <div className="hidden border-t border-neutral-200 dark:border-neutral-700 my-8"></div>

      {/* Upgrades Section */}
      <div className="hidden bg-neutral-100 dark:bg-neutral-700 rounded-lg border border-slate-300 dark:border-neutral-600 p-6">
        <h3 className="font-medium text-neutral-900 dark:text-white mb-4">Upgrades</h3>
        <p className="text-sm text-neutral-600 dark:text-neutral-400 mb-4">Individual bolt-on upgrades available for Creator and Pro packages.</p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="p-4 bg-white dark:bg-neutral-800 rounded-lg border border-slate-200 dark:border-neutral-600">
            <h4 className="font-medium text-neutral-900 dark:text-white mb-2">Creator Auto Build Templates</h4>
            <ul className="text-sm text-neutral-600 dark:text-neutral-400 space-y-1">
              <li>• Mobile App (iOS & Android)</li>
              <li>• Business API Service</li>
              <li>• Business Automation Tool</li>
              <li>• Interactive Web Application</li>
              <li>• Business Service Backend</li>
            </ul>
          </div>
          
          <div className="p-4 bg-white dark:bg-neutral-800 rounded-lg border border-slate-200 dark:border-neutral-600">
            <h4 className="font-medium text-neutral-900 dark:text-white mb-2">Pro & Creator Storage</h4>
            <ul className="text-sm text-neutral-600 dark:text-neutral-400 space-y-1">
              <li>• Bundles of 5GB Extra Storage</li>
              <li>• Additional App Hosting (per app)</li>
            </ul>
          </div>
          
          <div className="p-4 bg-white dark:bg-neutral-800 rounded-lg border border-slate-200 dark:border-neutral-600">
            <h4 className="font-medium text-neutral-900 dark:text-white mb-2">Pro Compliance</h4>
            <ul className="text-sm text-neutral-600 dark:text-neutral-400 space-y-1">
              <li>• Compliance Engine Upgrade</li>
              <li>• Contact our sales team for pricing</li>
              <li>• Flexible implementation options</li>
              <li>• Custom integration support</li>
            </ul>
          </div>
        </div>
        
        <div className="mt-6 text-center">
          <button 
            onClick={() => window.open('https://kolega.studio/contact.html', '_blank')}
            className="px-6 py-3 bg-brand-primary text-black font-medium rounded-lg hover:bg-brand-primaryDark transition-colors"
            data-tour="contact-sales-button"
          >
            Contact Sales
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlanSection; 